import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { LoaderFontStyle } from "@lib/titan2/dist/game/view/style/CommonFontStyle";
/**
 * GameFontStyle.ts
 */
export class GameFontStyle extends FontStyle {
}
GameFontStyle.BIG_WIN_TITLE = "GameFontStyle.BIG_WIN_TITLE";
GameFontStyle.BIG_WIN_VALUE = "GameFontStyle.BIG_WIN_VALUE";
GameFontStyle.FEATURE_GOLD_FISH_PICKED_PRIZE = "GameFontStyle.FEATURE_GOLD_FISH_PICKED_PRIZE";
GameFontStyle.FEATURE_GOLD_FISH_MISSED_PRIZE = "GameFontStyle.FEATURE_GOLD_FISH_MISSED_PRIZE";
GameFontStyle.GOLD_FISH_SYMBOL_VALUE = "GameFontStyle.GOLD_FISH_SYMBOL_VALUE";
GameFontStyle.GOLD_FISH_SYMBOL_MULTIPLIED_VALUE = "GameFontStyle.GOLD_FISH_SYMBOL_MULTIPLIED_VALUE";
GameFontStyle.GOLD_FISH_SPIN_COUNT_VALUE = "GameFontStyle.GOLD_FISH_SPIN_COUNT_VALUE";
GameFontStyle.GOLD_FISH_WIN_COUNT_VALUE = "GameFontStyle.GOLD_FISH_WIN_COUNT_VALUE";
GameFontStyle.GOLD_FISH_SPIN_COUNT_LABEL = "GameFontStyle.GOLD_FISH_SPIN_COUNT_LABEL";
GameFontStyle.GOLD_FISH_WIN_COUNT_LABEL = "GameFontStyle.GOLD_FISH_WIN_COUNT_LABEL";
GameFontStyle.GOLD_FISH_SPIN_WIN_VALUE = "GameFontStyle.GOLD_FISH_SPIN_WIN_VALUE";
GameFontStyle.GOLD_FISH_PAYTABLE_VALUE = "GameFontStyle.GOLD_FISH_PAYTABLE_VALUE";
GameFontStyle.GOLD_FISH_MULTIPLIER_VALUE = "GameFontStyle.GOLD_FISH_MULTIPLIER_VALUE";
GameFontStyle.GOLD_FISH_RESPIN_TITLE = "GameFontStyle.GOLD_FISH_RESPIN_TITLE";
GameFontStyle.FISH_FOOD_TURTLE_PICK = "GameFontStyle.FISH_FOOD_TURTLE_PICK";
GameFontStyle.FISH_FOOD_TURTLE_MISS = "GameFontStyle.FISH_FOOD_TURTLE_MISS";
GameFontStyle.FISH_FOOD_TOTAL_WIN_TITLE = "GameFontStyle.FISH_FOOD_TOTAL_WIN_TITLE";
GameFontStyle.FISH_FOOD_TOTAL_WIN_VALUE = "GameFontStyle.FISH_FOOD_TOTAL_WIN_VALUE";
GameFontStyle.FISH_FOOD_PANEL_VALUES = "GameFontStyle.FISH_FOOD_PANEL_VALUES";
GameFontStyle.FISH_FOOD_PANEL_WIN_VALUES = "GameFontStyle.FISH_FOOD_PANEL_WIN_VALUES";
GameFontStyle.FEATURE_TITLE = "GameFontStyle.FEATURE_TITLE";
GameFontStyle.FEATURE_HELP_TEXT = "GameFontStyle.FEATURE_HELP_TEXT";
GameFontStyle.FISH_FOOD_HELP_TEXT = "GameFontStyle.FISH_FOOD_HELP_TEXT";
GameFontStyle.FISH_FOOD_HELP_TEXT_PORTRAIT = "GameFontStyle.FISH_FOOD_HELP_TEXT_PORTRAIT";
GameFontStyle.FEATURE_GREEN_FISH_PICKED_PRIZE = "GameFontStyle.FEATURE_GREEN_FISH_PICKED_PRIZE";
GameFontStyle.FEATURE_GREEN_FISH_MISSED_PRIZE = "GameFontStyle.FEATURE_GREEN_FISH_MISSED_PRIZE";
GameFontStyle.FEATURE_RED_FISH_PRIZE_CHANGE = "GameFontStyle.FEATURE_RED_FISH_PRIZE_CHANGE";
GameFontStyle.FEATURE_RED_FISH_PICKED_PRIZE = "GameFontStyle.FEATURE_RED_FISH_PICKED_PRIZE";
GameFontStyle.FEATURE_RED_FISH_MISSED_PRIZE = "GameFontStyle.FEATURE_RED_FISH_MISSED_PRIZE";
GameFontStyle.FEATURE_PURPLE_FISH_PICKED_PRIZE = "GameFontStyle.FEATURE_PURPLE_FISH_PICKED_PRIZE";
GameFontStyle.FEATURE_PURPLE_FISH_DIGIT = "GameFontStyle.FEATURE_PURPLE_FISH_DIGIT";
GameFontStyle.FEATURE_PURPLE_FISH_MISSED_PRIZE = "GameFontStyle.FEATURE_PURPLE_FISH_MISSED_PRIZE";
GameFontStyle.FEATURE_SELECTOR_PICK_A_BONUS = "GameFontStyle.FEATURE_SELECTOR_PICK_A_BONUS";
GameFontStyle.FEATURE_SELECTOR_CHOICE = "GameFontStyle.FEATURE_SELECTOR_CHOICE";
GameFontStyle.FEATURE_INFO_TITLE = "GameFontStyle.FEATURE_INFO_TITLE";
GameFontStyle.FEATURE_INFO_HELP_TEXT = "GameFontStyle.FEATURE_INFO_HELP_TEXT";
GameFontStyle.FEATURE_INFO_HELP_TEXT_PORTRAIT = "GameFontStyle.FEATURE_INFO_HELP_TEXT_PORTRAIT";
GameFontStyle.FEATURE_INFO_TAP_TO_SKIP = "GameFontStyle.FEATURE_INFO_TAP_TO_SKIP";
GameFontStyle.FREE_SPINS_REMAINING = "GameFontStyle.FREE_SPINS_REMAINING";
GameFontStyle.TOTAL_WIN_TITLE = "GameFontStyle.TOTAL_WIN_TITLE";
GameFontStyle.TOTAL_WIN_VALUE = "GameFontStyle.TOTAL_WIN_VALUE";
GameFontStyle.PAY_TABLE_FULL_HOUSE_LABEL = "GameFontStyle.PAY_TABLE_FULL_HOUSE_LABEL";
GameFontStyle.PAY_TABLE_CELL_CURRENT_HIGHLIGHT_FULL_HOUSE_LABEL = "GameFontStyle.PAY_TABLE_CELL_CURRENT_HIGHLIGHT_FULL_HOUSE_LABEL";
GameFontStyle.PAY_TABLE_CELL_LABEL = "GameFontStyle.PAY_TABLE_CELL_LABEL";
GameFontStyle.PAY_TABLE_CELL_VALUE = "GameFontStyle.PAY_TABLE_CELL_VALUE";
GameFontStyle.PAY_TABLE_CELL_CURRENT_HIGHLIGHT_LABEL = "GameFontStyle.PAY_TABLE_CELL_CURRENT_HIGHLIGHT_LABEL";
GameFontStyle.PAY_TABLE_CELL_CURRENT_HIGHLIGHT_VALUE = "GameFontStyle.PAY_TABLE_CELL_CURRENT_HIGHLIGHT_VALUE";
GameFontStyle.PAY_TABLE_CELL_EXCEEDED_LABEL = "GameFontStyle.PAY_TABLE_CELL_EXCEEDED_LABEL";
GameFontStyle.PAY_TABLE_CELL_EXCEEDED_VALUE = "GameFontStyle.PAY_TABLE_CELL_EXCEEDED_VALUE";
GameFontStyle.MINI_PAY_TABLE_CELL_VALUE = "GameFontStyle.MINI_PAY_TABLE_CELL_VALUE";
GameFontStyle.MINI_PAY_TABLE_CELL_CURRENT_HIGHLIGHT_VALUE = "GameFontStyle.MINI_PAY_TABLE_CELL_CURRENT_HIGHLIGHT_VALUE";
GameFontStyle.MINI_PAY_TABLE_CELL_EXCEEDED_VALUE = "GameFontStyle.MINI_PAY_TABLE_CELL_EXCEEDED_VALUE";
/////////////////////////////////////////////////////
GameFontStyle.COLLECT_BUTTON_LARGE_TEXT = "GameFontStyle.COLLECT_BUTTON_LARGE_TEXT";
GameFontStyle.AVAILABLE_WIN_LABEL_MEDIUM = "GameFontStyle.AVAILABLE_WIN_LABEL_MEDIUM";
GameFontStyle.FULL_HOUSE_ANIMATION_TITLE = "GameFontStyle.FULL_HOUSE_ANIMATION_TITLE";
GameFontStyle.FULL_HOUSE_ANIMATION_COUNTER = "GameFontStyle.FULL_HOUSE_ANIMATION_COUNTER";
GameFontStyle.SCATTER_WIN_ANIMATION_TITLE = "GameFontStyle.SCATTER_WIN_ANIMATION_TITLE";
GameFontStyle.SCATTER_WIN_ANIMATION_COUNTER = "GameFontStyle.SCATTER_WIN_ANIMATION_COUNTER";
GameFontStyle.GAME_SUMMARY_TITLE = "GameFontStyle.GAME_SUMMARY_TITLE";
GameFontStyle.GAME_SUMMARY_TOTAL_WIN_TITLE = "GameFontStyle.GAME_SUMMARY_TOTAL_WIN_TITLE";
GameFontStyle.GAME_SUMMARY_TOTAL_WIN_VALUE = "GameFontStyle.GAME_SUMMARY_TOTAL_WIN_VALUE";
GameFontStyle.GAME_SUMMARY_SLINGOS_WIN_TITLE = "GameFontStyle.GAME_SUMMARY_SLINGOS_WIN_TITLE";
GameFontStyle.GAME_SUMMARY_SLINGOS_WIN_VALUE = "GameFontStyle.GAME_SUMMARY_SLINGOS_WIN_VALUE";
GameFontStyle.GAME_SUMMARY_BONUS_WIN_TITLE = "GameFontStyle.GAME_SUMMARY_BONUS_WIN_TITLE";
GameFontStyle.GAME_SUMMARY_BONUS_WIN_VALUE = "GameFontStyle.GAME_SUMMARY_BONUS_WIN_VALUE";
GameFontStyle.TICKET_SYMBOL_SUPER_DAB_HIGHLIGHT = "GameFontStyle.TICKET_SYMBOL_SUPER_DAB_HIGHLIGHT";
GameFontStyle.PLAYER_CONTROL_BUTTONS = "GameFontStyle.PLAYER_CONTROL_BUTTONS";
GameFontStyle.SCATTER_PANEL_TITLE = "GameFontStyle.SCATTER_PANEL_TITLE";
GameFontStyle.SCATTER_PANEL_FIELD = "GameFontStyle.SCATTER_PANEL_FIELD";
GameFontStyle.GAME_MESSAGES = "GameFontStyle.GAME_MESSAGES";
export class GameLoaderFontStyle extends LoaderFontStyle {
}
GameLoaderFontStyle.COPYRIGHT_PORTRAIT = "GameLoaderFontStyle.COPYRIGHT_PORTRAIT";
GameLoaderFontStyle.WIN_FIELD_SMALL = "GameLoaderFontStyle.WIN_FIELD_SMALL";
GameLoaderFontStyle.WIN_FIELD_LARGE = "GameLoaderFontStyle.WIN_FIELD_LARGE";
GameLoaderFontStyle.INFO_FIELD_LINE_1 = "GameLoaderFontStyle.INFO_FIELD_LINE_1";
GameLoaderFontStyle.INFO_FIELD_LINE_2 = "GameLoaderFontStyle.INFO_FIELD_LINE_2";
//# sourceMappingURL=GameFontStyle.js.map